<form [formGroup]="representanteForm" autocomplete="off">
  <div class="card">
    <div class="card-header">
      TITULAR
    </div>
    <div class="card-body pb-0">
      <div class="row">
        <label class="col-sm-3 col-12">Doc. Identidad:</label>
        <mat-form-field class="col-4 col-sm-4 pr-0" appearance="outline">
          <mat-select #fontSize placeholder="Seleccione" value="16px" formControlName="tipoDocumentoTitular"
            name="tipoDocumentoTitular">
            <mat-option *ngFor="let element of listTipoDocumento" [value]="element.codigo">
              {{element.descripcion}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('tipoDocumentoTitular')">{{obtenerMensajeError("tipoDocumentoTitular")}}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-8 col-sm-5 pl-0 ml-0" appearance="outline">
          <input matInput placeholder="" formControlName="numeroDocumentoTitular" name="numeroDocumentoTitular"
            maxlength="13" (keypress)="fnKeyDownAlphaNumeric($event)" (keyup)="fnAlphaNumericMobile($event)"
            (input)="fnInputMaxLength($event);" (change)="changeDocIdentidadTitular($event)">
          <mat-error *ngIf="hasError('numeroDocumentoTitular')">{{obtenerMensajeError("numeroDocumentoTitular")}}
          </mat-error>
          <button mat-mini-fab color="primary" matSuffix aria-label="Clear" (click)="buscarTitular()"  type="button"
            [disabled]="desHabilitarBtnBsqTitular()">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="row">
        <label class="col-sm-3 col-12">Nombres:</label>
        <mat-form-field class="col-12 col-sm-9" appearance="outline">
          <input matInput type="text" formControlName="nombresTitular" #nombres maxlength="100" readonly 
            (input)="fnInputMaxLength($event);">
          <mat-error *ngIf="hasError('nombresTitular')">{{obtenerMensajeError("nombresTitular")}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="card-header">
      REPRESENTANTE
    </div>
    <div class="card-body  pb-0">
      <div class="row">
        <label class="col-sm-3 col-12">Doc. Identidad:</label>
        <mat-form-field class="col-4 col-sm-4 pr-0" appearance="outline">
          <mat-select value="16px" placeholder="Seleccione" formControlName="tipoDocumento" name="tipoDocumento">
            <mat-option *ngFor="let element of listTipoDocumento" [value]="element.codigo">
              {{element.descripcion}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('tipoDocumento')">{{obtenerMensajeError("tipoDocumento")}}</mat-error>
        </mat-form-field>
        <mat-form-field class="col-8 col-sm-5 pl-0 ml-0" appearance="outline">
          <input matInput name="numeroDocumento" formControlName="numeroDocumento" maxlength="13" min="8" maxlength="13"
            (keypress)="fnKeyDownAlphaNumeric($event)" (keyup)="fnAlphaNumericMobile($event)"
            (input)="fnInputMaxLength($event);">
          <mat-error *ngIf="hasError('numeroDocumento')">{{obtenerMensajeError("numeroDocumento")}}</mat-error>
          <button mat-mini-fab type="button" color="primary" matSuffix aria-label="Clear" (click) = "buscarPersona()"
            [disabled]="this.representanteForm.controls['tipoDocumento'].invalid || this.representanteForm.controls['numeroDocumento'].invalid">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="row">
        <label class="col-sm-3 col-12">Nombres:</label>
        <mat-form-field class="col-12 col-sm-9" appearance="outline">
          <input matInput type="text" formControlName="nombres" #nombres maxlength="100" 
            (input)="fnInputMaxLength($event);">
          <mat-error *ngIf="hasError('nombres')">{{obtenerMensajeError("nombres")}}</mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <label class="col-sm-3 col-12">Apellidos:</label>
        <mat-form-field class="col-12 col-sm-9" appearance="outline">
          <input matInput type="text" formControlName="apellidos" name="apellidos" maxlength="100"
            (input)="fnInputMaxLength($event);">
          <mat-error *ngIf="hasError('apellidos')">{{obtenerMensajeError("apellidos")}}</mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <label class="col-sm-3 col-12">Email:</label>
        <mat-form-field class="col-12 col-sm-9" appearance="outline">
          <input matInput type="email" formControlName="correo" name="correo" maxlength="100"
            (input)="fnInputMaxLength($event);">
          <mat-error *ngIf="hasError('correo')">{{obtenerMensajeError("correo")}}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  
  <div class="row mt-3 justify-content-center">
    <div class="col-2">
      <button class="text-danger" mat-raised-button (click)='closeModal(false)'>
        Cancelar
      </button>
    </div>
    <div class="col-2">
      <button mat-raised-button color="primary" [disabled]="this.representanteForm.invalid" (click)="guardarRepresentante()">
        Guardar
      </button>
    </div>
  </div>
</form>